import axios from "axios";
import {ResponseFile, ResponseList} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {EDQuestion} from "../../models/serverModels/education/EDQuestion";

const manual = axios.create({
  baseURL: "/API",
});
export const UploadManual = async (params: Params.ImportFile): Promise<ResponseFile> =>
  manual({
    url: `/UploadManual`,
    method: "post",
    data: params,
  }).then((res) => res.data);
